import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";
import axios from "axios";
ReactSession.setStoreType("localStorage");

const Checkout = () => {
  const userId = ReactSession.get("welbeinguserId");
  const profile = ReactSession.get("welbeingprofile");
  const [cartItems, setCartItems] = useState([]);
  const [OrId, setOrderID] = useState(null);
  const [total, setTotal] = useState(0);
  const [gst, setgst] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [gtotal, setGTotal] = useState(0);
  const offer = sessionStorage.getItem("offer");
  const [addresses, setAddresses] = useState({});
  const [shippingaddress, setshippingaddress] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [error, setError] = useState("");
  const [preorders, setpreorders] = useState(false);
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  //cart
  const getCart = () => {
    const storedCartItems =
      JSON.parse(sessionStorage.getItem("cartItems")) || [];
      setCartItems(storedCartItems);
    //console.log(storedCartItems);
  };

  useEffect(() => {
    getCart();
    const intervalId = setInterval(() => {
      getCart();
    }, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (!cartItems || cartItems.length === 0) {
      setTotal(0);
      setGTotal(0);
      setShipping(0);
      setgst(0);
      return;
    }

    // Calculate sums
    let subtotal = 0;
    let total = 0;
    let weight = 0;

    cartItems.forEach((item) => {



      if (item.orderType === 'preorder') {
        setpreorders(true);
      }

      const itemWeight = parseFloat(item.weight.split(" ")[0]) || 0;
      subtotal += item.price * item.quantity;
      total += item.prices * item.quantity;
      weight += item.quantity * itemWeight;
    });

    // Calculate shipping
    let shipping;
    if (weight <= 1000) shipping = 70;
    else if (weight <= 2000) shipping = 120;
    else if (weight <= 3000) shipping = 140;
    else if (weight <= 4000) shipping = 180;
    else if (weight <= 5000) shipping = 220;
    else shipping = 250;

    // Calculate offer discount (capped at 100)
    // let discountAmount;
    // let c_total = total * (offer / 100);
    // if (c_total > 100) {
    //   discountAmount = 100;
    // } else {
    //   discountAmount = c_total;
    // }

    // Calculate grand total
    const gTotal = Number(total) - Number(offer) + Number(shipping);


    // Update state
    setTotal(subtotal);
    setgst(total - subtotal);
    setShipping(shipping);
    setGTotal(gTotal);
  }, [cartItems, offer]);

  const handleAddressSelection = (addressId) => {
    setSelectedAddressId(addressId);

    // Find the selected address
    const selectedAddress = addresses?.data?.find(item => item.id === addressId);

    if (selectedAddress) {
      // Do something with the selected address
      //console.log('Selected address:', selectedAddress);
      // You might want to set the entire address object in state
      setSelectedAddress(selectedAddress);


    }
  };

  const fetchAddressData = async () => {
    try {
      const response = await axios.post(
        "https://api.welbeing.in/address/get-address/",
        { cust_id: userId }
      );
      const fetchedAddresses = response.data;
      setAddresses(fetchedAddresses);
      //console.log(response.data);

      if (fetchedAddresses.count > 0) {
        const lastAddressId =
          fetchedAddresses.data[fetchedAddresses.data.length - 1].id;
        if (selectedAddressId === "" || selectedAddressId === null) {
          setSelectedAddressId(lastAddressId);
          handleAddressSelection(lastAddressId);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAddressData();
    handleAddressSelection(selectedAddressId);
  }, [selectedAddressId]);

  //console.log(selectedAddressId);

  const handleAddressdelete = async (addressId) => {
    try {
      const response = await axios.post(`https://api.welbeing.in/address/delete-address/`, { id: addressId });
      fetchAddressData();

    } catch (error) {
      console.error('There was a problem with login:', error);
      setError('Not Inserted');
    }
  };

 const  handleAddComment= (event) => {

   
    setComments(event.target.value);
  };




  const handleAddChange = (event) => {

    const name = event.target.name;
    const value = event.target.value;
    if(name === 'pin'){
      if(value?.length === 7){
        return;
      }
    }
    setshippingaddress((values) => ({ ...values, [name]: value }));
  };


  const handleAddSubmit = async (event) => {
  event.preventDefault();
  
  const formData = {
    cust_id: userId,
    name: shippingaddress.name,
    phone: shippingaddress.phonenumber,
    email: shippingaddress.email,
    address: shippingaddress.address,
    location: shippingaddress.city,
    pin: shippingaddress.pin,
    state: shippingaddress.state,
    comment: shippingaddress.comment,
  };

  // Check if shippingaddress exists and has at least one property
  if (!shippingaddress || Object.keys(shippingaddress).length === 0) {
    // alert("Please add a shipping address first");
    return;
  }

  try {
    // Add address
    const addressResponse = await axios.post(
      "https://api.welbeing.in/address/add-address/",
      formData
    );

    // Check if address was successfully added
    if (addressResponse.data.status === "success") {
      // Process payment after successful address addition
      await processPayment(event);
    } else {
      throw new Error("Address not inserted successfully");
    }
  } catch (error) {
    console.error("Error in submission:", error);
    setError(error.message || "Failed to process order");
  }
};


  const processPayment = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    
    if(userId === "0"){
      if(!shippingaddress.name || !shippingaddress.phonenumber || !shippingaddress.address || !shippingaddress.city || !shippingaddress.state || !shippingaddress.pin || !shippingaddress.email){
        setError('Please fill all fileds!');
        setLoading(false);
        return;
      }else if(shippingaddress.pin.length !== 6 ){
        setError('Pincode must be 6 digits!');
        setLoading(false);
        return;
      }else if(shippingaddress.phonenumber.length < 10 ){
        setError('Contact number atleast 10 digits!');
        setLoading(false);
        return;
      }
    }

    const dt = new Date();
    const time = userId + dt.getFullYear().toString() + (dt.getMonth() + 1).toString().padStart(2, '0') + dt.getDate().toString().padStart(2, '0') + dt.getHours().toString().padStart(2, '0') + dt.getMinutes().toString().padStart(2, '0') + dt.getSeconds().toString().padStart(2, '0');
    const orderId = time;

    setOrderID(time);

    const senddata = {
      cust_id: userId,
      total: total,
      g_total: gtotal,
      offer: offer,
      comments: comments,
      totalgst: gst,
      shipping: shipping,
        ...(userId === "0" ? { shippingAddress: shippingaddress } : { addressId: selectedAddressId }),
      products: cartItems.map(item => ({
        item_id: item.id,
        code: item.code,
        name: item.product,
        price: item.price,
        prices: item.prices,
        mrp: item.mrp,
        quantity: item.quantity,
        img: item.image,
        weight: item.weight,
        color: item.color,
        design: item.design,
        size: item.size,
        preOrder: item.orderType,
      }))
    };

    // console.log(senddata);

    try {
      const response = await axios.post(`https://api.welbeing.in/payment/razorpay/`, senddata);
      
      const razorderId = response.data.razorpay_order_id;

      console.log(response.data);
      
      //console.log(response.data.RazId);
      
      //console.log("Navigating to payment...");
     
        // alert("Address added and payment processed successfully");
        navigate("/payment", {
        state: {
          razId: response.data.razorpay_order_id,
          amount: response.data.amount,
          orderId: response.data.order_id,
          name: response.data.customer.name,
          phone: response.data.customer.phone,
          email: response.data.customer.email,
          address: response.data.customer.address
        }
      });

      sessionStorage.removeItem('cartItems');
      sessionStorage.removeItem('offer');
      sessionStorage.removeItem('coupon');

      //navigate(`/payment?id=${orderId}&orderId=${razorderId}`);
      //navigate(`/processsucess?id=${orderId}`);
     
    } catch (error) {
      console.error('error', error);
      setError('Not Inserted');
      //console.log(error);
    }
    setLoading(false);
  }



  return (
    <>
      <Header />
      <main className="main">
        {/* Breadcrumb Start */}
        <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{minHeight:'10px'}}>
            <img
              className="bg-img bg-top"
              src="assets/images/inner-page/banner-p.jpg"
              alt="banner"
            />
            <div className="container-lg">
              <div className="breadcrumb-box">
                <div className="heading-box">
                  <h1>Checkout</h1>
                </div>
                <ol className="breadcrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i data-feather="chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a href="cart.php">Cart</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i data-feather="chevron-right"></i>
                    </a>
                  </li>
                  <li className="current">
                    <a href="/checkout">Checkout</a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* Breadcrumb End */}

        {/* Checkout Section Start */}
        <section className="checkout">
          <div className="container-lg">
            <form>
              <div className="row g-3 g-sm-4 cart">

                {preorders ? (<p class="text-center text-danger">Your cart contains a pre-order item. Our team will contact you shortly to confirm the estimated delivery date.</p>) : (<></>)}

                {userId === "0" ? (
                  <div className="col-md-7 col-lg-8 col-xl-9">

                    {/* Guest User Checkout  */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="blog-wrap">
                          <div className="comments-section top-space">
                            <div className="comment-wrapper">
                              <div
                                className="comment-box"
                                style={{ justifyContent: "center" }}
                              >
                                <div className="sender-details">
                                  <h5>If you already have an account please</h5>
                                </div>
                              </div>
                              <div
                                style={{ justifyContent: "center" }}
                                align="center"
                              >
                                <a
                                  href="/login"
                                  className="btn btn-solid btn-sm replay-btn mt-3 mb-3"
                                >
                                  Login
                                </a>
                                <h5>OR</h5>
                                <a
                                  href="/register"
                                  className="btn btn-solid btn-sm replay-btn mt-2"
                                >
                                  Create an account
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8 mt-4">
                        <div className="row">
                          <div className="col-md-6 pb-3">
                            <input type="text" className="form-control" name="name" placeholder="First name*" value={shippingaddress.name} onChange={handleAddChange} required />

                          </div>
                          <div className="col-md-6 pb-3">
                            <input type="text" name="phonenumber" className="form-control" placeholder="Whatsapp number*" value={shippingaddress.phonenumber} onChange={handleAddChange} required />
                          </div>
                          <div className="col-md-12 pb-3">
                            <input type="text" name="address" className="form-control" placeholder="Enter Address*" value={shippingaddress.address} onChange={handleAddChange} required />
                          </div>
                          <div className="col-md-6 pb-3">
                            <input type="text" name="city" className="form-control" placeholder="Enter Town/city*" value={shippingaddress.city} onChange={handleAddChange} required />
                          </div>
                          <div className="col-md-6 pb-3">
                            <input type="text" name="state" className="form-control" placeholder="Enter state*" value={shippingaddress.state} onChange={handleAddChange} required />

                          </div>
                          <div className="col-md-6 pb-3">
                            <input type="text" name="pin" className="form-control" placeholder="Enter Pincode/ Zip *" value={shippingaddress.pin} onChange={handleAddChange} required />
                          </div>
                          <div className="col-md-6 pb-3">
                            <input type="text" name="email" className="form-control" placeholder="Email*" value={shippingaddress.email} onChange={handleAddChange} required />
                          </div>
                          <div className="col-md-12 pb-3">
                            <textarea
                              className="form-control mt-2"
                              rows="5"
                              name="comment"
                              placeholder="Special message to seller..."
                              value={shippingaddress.comment}
                              onChange={handleAddChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  /* Logged-in User Checkout */
                  <>
                    <div className="col-lg-12">
                      <div className="blog-wrap">
                        <div className="comments-section round-wrap-content top-space">
                          <div className="comment-wrapper">
                            <div className="comment-box">
                              <div className="img-box">
                                <img
                                  src={`https://api.welbeing.in/uploads/${profile}`}
                                  alt="profile"
                                />
                              </div>
                              <div className="sender-details">
                                <h5>
                                  {ReactSession.get("welbeinguserName")}
                                </h5>
                                <p>{ReactSession.get("welbeingemail")}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-7 col-lg-8 col-xl-9">
                      <div class="address-wrap">
                        <div class="title-box2">
                          {addresses && addresses.data && addresses.data.length > 0 && (
                            <h2 class="heading-2">Select Delivery Address</h2>
                          )}
                        </div>

                        <div class="row g-3 g-md-4">
                           <div className="col-md-12 pb-3">
                            <textarea
                              className="form-control mt-2"
                              rows="5"
                              name="comment"
                              placeholder="Special message to seller..."
                              value={comments}
                              onChange={handleAddComment}
                            required></textarea>
                          </div>
                           

                          {addresses && addresses.data && addresses.data.slice().reverse().slice(-4).map(address => (
                            
                            <div className='col-lg-6 col-md-12 col-12 mt-4' style={{ minHeight: '220px' }}>
                              <div className='address-box checked'>
                                <div className='radio-box'>
                                  <div>
                                    <input
                                      className='radio-input'
                                      type='radio'
                                      name='addressId'
                                      required
                                      id={`address-${address.id}`}
                                      onChange={() => handleAddressSelection(address.id)}
                                      checked={selectedAddressId === address.id}
                                    />
                                    <label className='radio-label' htmlFor={`address-${address.id}`}></label>
                                  </div>
                                  <span className='badges badges-pill badges-theme'>{address.name}</span>
                                  <div className='option-wrap'>
                                    <button
                                      className='delet ms-0'
                                      onClick={() => handleAddressdelete(address.id)}
                                    >
                                      <i class="fa fa-trash" style={{ color: "#767676" }}></i>
                                    </button>
                                  </div>
                                </div>

                                <div className='address-detail'>
                                  <p className='product-short-desc'><small>{address.address}</small></p>
                                  <small className='content-color font-default'>
                                    Mobile: <span className='title-color font-default fw-500'>{address.phonenumber}</span>
                                  </small><br />
                                  <small className='content-color font-default'>
                                    Email: <span className='title-color font-default fw-500'>{address.email}</span>
                                  </small><br />
                                  <small className='content-color font-default mt-1'>
                                    City: <span className='title-color font-default fw-500'>{address.city}</span>
                                  </small><br />
                                  <small className='content-color font-default mt-1'>
                                    Pincode: <span className='title-color font-default fw-500'>{address.pincode}</span>
                                  </small>
                                 
                                </div>

                                
                              </div>
                            </div>

                          ))}
                          <div class='col-12 col-xl-6'>
                            <div class='card'>
                              <div class='address-box add-new d-flex flex-column gap-2 align-items-center justify-content-center' data-bs-toggle='modal' data-bs-target='#addNewAddress'>
                                <a href='/addaddress'><span class='plus-icon'><i data-feather='plus'></i></span></a>
                                <h4 class='theme-color font-xl fw-500'>Add New Address</h4>
                              </div>
                            </div>
                          </div>
                         

                        </div>
                      </div>
                    </div>
                  </>
                )}


                {/* Order Summary - Shown for both guest and logged-in users */}
                <div className="col-md-5 col-lg-4 col-xl-3">
                  <div className="summery-wrap">
                    <div className="cart-wrap grand-total-wrap">
                      <div>
                        <div className="order-summery-box">
                          <h5 className="cart-title">Cart Totals</h5>
                          <ul className="order-summery">
                            <li>
                              <span>Subtotals:</span>
                              <span>₹{total.toFixed(2)}</span>
                            </li>
                            <li>
                              <span>Gst:</span>
                              <span className="theme-color">
                                ₹ {gst.toFixed(2)}
                              </span>
                            </li>
                            <li>
                              <span>Shipping:</span>
                              <span className="theme-color">
                                ₹ {shipping.toFixed(2)}
                              </span>
                            </li>
                            {offer > 0 && (
                              <li className="coupon-discount">
                                <span>Coupon Discount</span>
                                <span>-₹{offer}</span>
                              </li>
                            )}
                            <li className="pb-0">
                              <span>Total Amount</span>
                              <span>₹{gtotal.toFixed(2)}</span>
                            </li>
                          </ul>
                          <div className="row g-3 mt-2">
                            {(shippingaddress && Object.keys(shippingaddress).length > 0) > 0 || selectedAddressId !== null ? (
                              <>
                                {userId === "0" ? (
                                  <div className="col-6 col-md-12">
                                    <button
                                      onClick={handleAddSubmit}
                                      className="btn-solid checkout-btn"
                                    >
                                      {loading ? 'Processing...' :' Proceed to Payment'}<i className="arrow"></i>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="col-6 col-md-12">
                                    <button
                                      type="submit"
                                      onClick={processPayment}
                                      className="btn-solid checkout-btn"
                                    >
                                      {loading ? 'Processing...' :' Proceed to Payment'}<i className="arrow"></i>
                                    </button>
                                  </div>
                                )}
                              </>
                            ) : (<><p class="text-danger mt-30 text-center">Please add/select address and then Continue to payment</p>
                              <div className="col-6 col-md-12">
                                <button
                                  onClick={handleAddSubmit}
                                  className="btn-solid checkout-btn"
                                >
                                  {loading ? 'Processing...' :' Proceed to Payment'}<i className="arrow"></i>
                                </button>
                              </div></>)}

                                {error && <p className="text-danger text-center">{error}</p> }

                            <div className="col-6 col-md-12">
                              <a
                                href="/shop"
                                className="btn-outline w-100 justify-content-center checkout-btn"
                              >
                                Back To Shop
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
        {/* Checkout Section End */}
      </main>
      <Footer />
    </>
  );
};

export default Checkout;
